import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SafeUrlPipeModule } from '../pipes/safe-url.pipe';
import { TranslatePipeModule } from '../shared/translate.pipe';
import { WindowService } from '../shared/window.service';
import { PlatformTourPageComponent } from './platform-tour-page/platform-tour-page.component';
import { PlatformTourService } from './platform-tour-service/platform-tour.service';
import { PlatformTourModalComponent } from './platform-tour-modal/platform-tour-modal.component';
import { UserwaySyncModule } from '../shared/userway-sync.directive';

@NgModule({
  imports: [CommonModule, TranslatePipeModule, SafeUrlPipeModule, UserwaySyncModule],
  declarations: [PlatformTourPageComponent, PlatformTourModalComponent],
  providers: [WindowService, PlatformTourService],
  entryComponents: [PlatformTourModalComponent]
})
export class PlatformTourModule {}



// WEBPACK FOOTER //
// ./ts/app/platform-tour/platform-tour.module.ts